import { forwardRef, type Ref, type SVGProps } from "react";
const IconPaintRollerOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M18.193 24.61a1 1 0 0 1 1.091.22.997.997 0 0 1-.714 1.701.998.998 0 0 1-.377-1.92"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 2c1.06 0 2.078.42 2.828 1.169A4 4 0 0 1 30 5.99v1.996a4 4 0 0 1-1.172 2.823A4 4 0 0 1 26 11.978H10a4 4 0 0 1-2.83-1.168A4 4 0 0 1 6 7.987H5a1 1 0 0 0-1 .998v3.992c.002.55.448.996 1 .998h11.5a3.006 3.006 0 0 1 3 2.994v.02a2.984 2.984 0 0 1 2.81 2.624L23 25.45a4.49 4.49 0 0 1-2.232 3.939 4.51 4.51 0 0 1-4.536 0A4.49 4.49 0 0 1 14 25.45l.69-5.837a2.98 2.98 0 0 1 2.81-2.625v-.02a1 1 0 0 0-1-.997H5a3.007 3.007 0 0 1-3-2.995v-3.99A3.007 3.007 0 0 1 5 5.99h1c0-1.058.42-2.074 1.17-2.822A4 4 0 0 1 10 2zm-8.33 16.964a1.005 1.005 0 0 0-1 .879L16 25.55a2.5 2.5 0 0 0 2.5 2.398A2.5 2.5 0 0 0 21 25.55l-.67-5.708a1.006 1.006 0 0 0-1-.88zM10 3.995a2.005 2.005 0 0 0-2 1.996v1.996a2.004 2.004 0 0 0 2 1.996h16a2.004 2.004 0 0 0 2-1.996V5.991a2.005 2.005 0 0 0-2-1.996z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPaintRollerOutlineSVG);
ForwardRef.displayName = "IconPaintRollerOutline";
export { ForwardRef as IconPaintRollerOutline };
